var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#930505",
    d: "M494.83,170.37a4.395,4.395,0,0,1-1.48,1.04l-83.04-66.02,50.37-16.73a4.364,4.364,0,0,1,1.29,1.38l33.42,75.12A4.386,4.386,0,0,1,494.83,170.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba2020",
    d: "M161.25,227.35H351.98a4.508,4.508,0,0,0,.97-.11L257.81,451.85a4.388,4.388,0,0,1-6.5-.02L160.36,227.26A4.406,4.406,0,0,0,161.25,227.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#930505",
    d: "M161.57,127.2l-.02.08-1.19,99.98L104.4,106.54l56.36,20.42A5.411,5.411,0,0,0,161.57,127.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb6c1",
    d: "M104.4,106.53v.01l55.96,120.72a4.115,4.115,0,0,1-.84-.27L18.66,171.47a4.389,4.389,0,0,1-1.56-1.13,1.267,1.267,0,0,1-.11-.13,4.379,4.379,0,0,1-.3-5.13l86.71-58.91h.01Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d83a3a",
    d: "M103.4 106.17L16.69 165.08l37.17-75.2a4.23 4.23 0 011.19-1.23zM161.55 127.28l.02-.08a4.6 4.6 0 00.84.08h92.36l-94.41 99.98zM408.24 106.08L352.95 227.24l-8.48-99.96-.01-.07a3.859 3.859 0 00.74-.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba0404",
    d: "M460.68,88.66l-50.37,16.73-2.07.69L345.2,127.01a3.859,3.859,0,0,1-.74.2,4.114,4.114,0,0,1-.78.07H162.41a4.6,4.6,0,0,1-.84-.08,5.411,5.411,0,0,1-.81-.24L104.4,106.54v-.01l-.99-.36h-.01L55.05,88.65a3.863,3.863,0,0,1,1.2-.6l93.68-29.13a4.526,4.526,0,0,1,1.31-.2h203.6a4.387,4.387,0,0,1,1.19.17L459.38,88.05A4.307,4.307,0,0,1,460.68,88.66Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb6c1",
    d: "M161.25 227.35a4.406 4.406 0 01-.89-.09l94.41-99.98h2.44l95.74 99.96a4.508 4.508 0 01-.97.11zM410.31 105.39l83.04 66.02L353.73 226.99a4.173 4.173 0 01-.78.25l55.29-121.16z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#930505",
    d: "M344.47,127.28l8.48,99.96-95.74-99.96h86.47a4.114,4.114,0,0,0,.78-.07Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc8692",
    d: "M160.36,227.26l90.95,224.57L17.1,170.34a4.389,4.389,0,0,0,1.56,1.13l140.86,55.52A4.115,4.115,0,0,0,160.36,227.26Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fb6771",
    d: "M494.83,170.37,257.81,451.85l95.14-224.61a4.173,4.173,0,0,0,.78-.25l139.62-55.58A4.395,4.395,0,0,0,494.83,170.37Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce919d",
    d: "M46.414,182.409a4.423,4.423,0,0,1,.129-4.562L71.151,128.08l-54.461,37a4.379,4.379,0,0,0,.3,5.13,1.267,1.267,0,0,0,.11.13,4.389,4.389,0,0,0,1.56,1.13Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#af3131",
    d: "M84.408,101.268a4.13,4.13,0,0,1,1.212-1.2,1.976,1.976,0,0,1,.365-.21L55.05,88.65a4.23,4.23,0,0,0-1.19,1.23l-37.17,75.2,54.461-37Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#910606",
    d: "M86.843,99.708,213.586,59H151.24a4.423,4.423,0,0,0-1.31.06L56.25,88.12a3.777,3.777,0,0,0-1.2.565L85.985,99.947A6.688,6.688,0,0,1,86.843,99.708Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#c66674",
    d: "M46.848,183.06a4.522,4.522,0,0,1-.434-.651L18.66,171.47a4.389,4.389,0,0,1-1.56-1.13L251.31,451.83l-18.185-44.9L46.96,183.185A1.275,1.275,0,0,1,46.848,183.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiamond);
export default __webpack_public_path__ + "static/media/icon_diamond.8449107c9d6d8247457bb857c7e753c2.svg";
export { ForwardRef as ReactComponent };